import styled from 'styled-components';

export const TableGrantAcceptanceModifier = styled.div`
  tr [role='cell'] > div {
    text-align: left !important;
    justify-content: flex-start;
  }
  .child-row td:last-child > div {
    text-align: center !important;
  }
`;
